var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLanguageEng = function SvgLanguageEng(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#262626",
    d: "M21 0H3C1.345 0 0 1.345 0 3v13.5c0 1.655 1.345 3 3 3h4.5v3.938a.56.56 0 0 0 .895.45L14.25 19.5H21c1.655 0 3-1.345 3-3V3c0-1.655-1.345-3-3-3m.75 16.5c0 .413-.337.75-.75.75h-7.5l-.6.45-3.15 2.363V17.25H3a.75.75 0 0 1-.75-.75V3c0-.413.337-.75.75-.75h18c.413 0 .75.337.75.75z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#262626",
    d: "M7.05 7.824H4.634v1.45H6.98v.855H4.633v2.016H7.05V13H3.723V6.969H7.05zM7.847 13V6.559l4.399 4.601V6.97h.91v6.398l-4.399-4.59V13zm9.522-3.14h2.492v.199q0 .68-.16 1.203-.156.485-.527.906-.84.945-2.137.945-1.266 0-2.168-.914a3.03 3.03 0 0 1-.902-2.203q0-1.312.918-2.226.918-.918 2.234-.918.707 0 1.32.289.585.289 1.153.937l-.649.621q-.743-.988-1.808-.988-.957 0-1.606.66-.648.648-.648 1.625 0 1.008.722 1.66.676.606 1.465.606.672 0 1.207-.453.535-.458.598-1.094h-1.504z"
  })));
};
export default SvgLanguageEng;